import React, { Component } from 'react';
import {
    Grid,
    TableContainer,
    Paper,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Tooltip,
    Zoom
} from "@material-ui/core";
import moment from 'moment'
import NumberFormat from "react-number-format";
import { withTranslation } from 'react-i18next';

class GroupSummaryTab extends Component {

    render() {
        let { groupSummaries , selectedInventory, selectedClient, selectedFrom, selectedTo, selectedRadioButton, history} = this.props

        let groupSummariesList;
        let recordsNotFound;
        if (groupSummaries && groupSummaries.length > 0) {
            groupSummariesList = groupSummaries.map((groupSummary, index) => {
                return <TableRow key={index}>
                    <TableCell>
                        <Tooltip interactive disableFocusListener disableTouchListener transitioncomponent={Zoom} arrow title={<div style={{ fontSize: '14px' }} >
                            <p><b>{this.props.t("account_group")}:</b> {groupSummary.depreciationGroup && groupSummary.depreciationGroup.accountGroup}</p>
                            <p><b>{this.props.t("regular_rate")}:</b> {groupSummary.depreciationGroup && groupSummary.depreciationGroup.regularRate}</p>
                            <p><b>{this.props.t("accelerated_rate")}:</b> {groupSummary.depreciationGroup && groupSummary.depreciationGroup.acceleratedRate}</p>
                        </div>}>
                            <span style={{ cursor: 'pointer', color: '#094b79', textDecoration: 'underline dotted' }} onClick={() => history.push({
                                pathname: '/assets',
                                state: {
                                    selectedInventory: selectedInventory,
                                    selectedClient: selectedClient,
                                    selectedDepreciationGroup: groupSummary.depreciationGroup,
                                    selectedFrom: moment(selectedFrom).format("DD-MM-YYYY"),
                                    selectedTo: moment(selectedTo).format("DD-MM-YYYY"),
                                    selectedRadioButton: selectedRadioButton
                                }
                            })}>{groupSummary.depreciationGroup && groupSummary.depreciationGroup.name}</span>
                        </Tooltip>
                    </TableCell>
                    <TableCell className="custom-table-cell-numbers"><NumberFormat displayType="text" decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} value={groupSummary.previousDepreciation} /> </TableCell>
                    <TableCell className="custom-table-cell-numbers"><NumberFormat displayType="text" decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} value={groupSummary.currentDepreciation} /></TableCell>
                    <TableCell className="custom-table-cell-numbers"><NumberFormat displayType="text" decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} value={groupSummary.remainingDepreciation} /></TableCell>
                    <TableCell className="custom-table-cell-numbers"><NumberFormat displayType="text" decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} value={groupSummary.purchaseAmount} /></TableCell>
                    <TableCell className="custom-table-cell-numbers"><NumberFormat displayType="text" decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} value={groupSummary.residualValue} /></TableCell>
                </TableRow>
            });
        } else {
            recordsNotFound = <TableRow>
                <TableCell align="center" colSpan={6}>
                    <p>{this.props.t("no_records_found")}</p>
                </TableCell>
            </TableRow>
        }

        return (
            <Grid container direction="row" spacing={2}>
                <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Grid container direction="row" spacing={2}>
                        <Grid item container>
                            <TableContainer component={Paper}>
                                <Table aria-label="simple table" size="small" style={{ tableLayout: 'fixed' }}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell component="th" scope="row" width="25%">{this.props.t("group")}</TableCell>
                                            <TableCell component="th" scope="row" align="right" width="15%">{this.props.t("previous_depreciation")}</TableCell>
                                            <TableCell component="th" scope="row" align="right" width="15%">{this.props.t("amount_time_period")}</TableCell>
                                            <TableCell component="th" scope="row" align="right" width="15%">{this.props.t("amount_after_period")}</TableCell>
                                            <TableCell component="th" scope="row" align="right" width="15%">{this.props.t("purchase_amount")}</TableCell>
                                            <TableCell component="th" scope="row" align="right" width="15%">{this.props.t("residual_value")}</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {groupSummariesList}
                                        {groupSummaries.length > 0 && <TableRow style={{ borderTop: '2px solid #000' }}>
                                            <TableCell className="custom-table-cell">{this.props.t("sum")}</TableCell>
                                            <TableCell className="custom-table-cell-1"><NumberFormat displayType="text" decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} value={this.props.previousDepreciation} /></TableCell>
                                            <TableCell className="custom-table-cell-1"><NumberFormat displayType="text" decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} value={this.props.currentDepreciation} /></TableCell>
                                            <TableCell className="custom-table-cell-1"><NumberFormat displayType="text" decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} value={this.props.remainingDepreciation} /></TableCell>
                                            <TableCell className="custom-table-cell-1"><NumberFormat displayType="text" decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} value={this.props.purchaseAmount} /></TableCell>
                                            <TableCell className="custom-table-cell-1"><NumberFormat displayType="text" decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} value={this.props.residualValue} /></TableCell>
                                        </TableRow>}
                                        {recordsNotFound}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    }
}

export default withTranslation()(GroupSummaryTab);
